import {useDisplayMobile} from '@/logged/common/composables';
import {setCssVariable} from '@/logged/common/utils';
import {endpointExists} from '@/logged/config';
import {defineStore} from 'pinia';
import {computed, ref} from 'vue';
import {asideMenuEndpoints} from '../aside-menu.endpoints';
import {NavBarDisplayMode, NavBarWidth} from '../aside-menu.types';

/** Pinia store, dot not destructure */
export const useDisplayMode = defineStore('display-mode', () => {
    const displayMode = ref<NavBarDisplayMode>(window.navbarDisplayMode);

    const {isDisplayMobile} = useDisplayMobile();

    const isDisplayModeFunnel = computed<boolean>(() => displayMode.value === NavBarDisplayMode.FUNNEL);
    const isDisplayModeFull = computed<boolean>(() => displayMode.value === NavBarDisplayMode.FULL);
    const isDisplayModeReduced = computed<boolean>(() => displayMode.value === NavBarDisplayMode.REDUCED && !isDisplayMobile.value);

    setNavBarDisplayMode(window.navbarDisplayMode);

    async function setNavBarDisplayMode(mode?: NavBarDisplayMode): Promise<void> {
        const finalMode = mode ?? displayMode.value;
        const width = getDisplayModeNavbarWidth(finalMode);
        setCssVariable('--aside-menu-width', width);
        setCssVariable('--layout-padding-left', width);
        displayMode.value = finalMode;
        await saveDisplayMode(finalMode);
    }

    function toggleNavBarDisplayMode(): void {
        if (displayMode.value === NavBarDisplayMode.FULL) {
            setNavBarDisplayMode(NavBarDisplayMode.REDUCED);
        } else {
            setNavBarDisplayMode(NavBarDisplayMode.FULL);
        }
    }

    function getDisplayModeNavbarWidth(mode: NavBarDisplayMode) {
        switch (mode) {
            case NavBarDisplayMode.FULL:
                return `${NavBarWidth.FULL}px`;
            case NavBarDisplayMode.REDUCED:
                return `${NavBarWidth.REDUCED}px`;
            case NavBarDisplayMode.FUNNEL:
                return `0px`;
        }
    }

    async function saveDisplayMode(mode: NavBarDisplayMode) {
        try {
            if (endpointExists('changeNavbarState') && mode !== NavBarDisplayMode.FUNNEL) {
                await asideMenuEndpoints().updateNavBarState({state: mode});
            }
        } catch (e) {}
    }

    return {
        displayMode,
        isDisplayModeFunnel,
        isDisplayModeFull,
        isDisplayModeReduced,
        setNavBarDisplayMode,
        toggleNavBarDisplayMode,
    };
});
